import axios from "axios";
import { useCallback } from "react";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

export default function useEntity() {
  const getVendor = useCallback(async (vendorId) => {
    if (!vendorId) {
      return {};
    }

    try {
      const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor?id=${vendorId}`);
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }
      return {};
    } catch(e) {
      return {};
    }

  }, []);

  const getUserVendor = useCallback(async () => {
    try {
      const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor/my`);

      return (await response).data;
    } catch(e) {
      return {};
    }

  }, []);

  const getAgency = useCallback(async (agencyId) => {
    try {
      const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/agency?id=${agencyId}`);

      return (await response).data;
    } catch(e) {
      return {};
    }

  }, []);

  const getUserAgency = useCallback(async () => {
    try {
      const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/agency/my`);

      return (await response).data;
    } catch(e) {
      return {};
    }

  }, []);

  const updateVendor = useCallback(async (vendor) => {
    // Axios is configured to resolve 4xx, so a failed patch must be thrown or VendorEdit
    // treats the error body as a successful save.
    const response = await axios.patch(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor`, vendor);
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to update vendor");
      err.response = response;
      throw err;
    }
    return response.data;
  }, []);

  const updateAgency = useCallback(async (agencyId, agency) => {
    // Axios is configured to resolve 4xx, so a failed patch must be thrown or VendorEdit
    // treats the empty/error body as a successful save.
    const response = await axios.patch(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/agency/${agencyId}`, agency);
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to update agency");
      err.response = response;
      throw err;
    }
    return response.data;
  }, []);

  const getAgencies = useCallback(async () => {
    try {
      const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/agency/all`);
      return (await response).data;
    } catch(e) {
      return [];
    }
  }, []);

  const getVendors = useCallback(async () => {
    try {
      const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor/all`);
      return (await response).data;
    } catch(e) {
      return [];
    }
  }, []);

  const createVendor = useCallback(async (vendorData) => {
    // Axios is configured to resolve 4xx, so a failed create must be thrown or
    // OrganizationCreate treats a 409 duplicate name as a generic save failure.
    const response = await axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor`, vendorData);
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to create vendor");
      err.response = response;
      throw err;
    }
    return response;
  }, []);

  const createAgency = useCallback(async (agencyData) => {
    // Axios is configured to resolve 4xx, so a failed create must be thrown or
    // OrganizationCreate treats a 409 duplicate name as a generic save failure.
    const response = await axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/agency`, agencyData);
    if (response.status < 200 || response.status >= 300) {
      const err = new Error("Unable to create agency");
      err.response = response;
      throw err;
    }
    return response;
  }, []);

  return {getVendor, getVendors, getUserVendor, updateVendor, updateAgency, getAgencies, getAgency, getUserAgency, createVendor, createAgency}
}
